export const navItems = [
  { id: "intro", label: "作品速览" },
  { id: "story", label: "故事简介" },
  { id: "characters", label: "主要角色" },
  { id: "arcs", label: "篇章导览" },
  { id: "flames", label: "死气之炎" },
  { id: "channels", label: "观看渠道" },
  { id: "order", label: "补番指南" },
  { id: "faq", label: "常见问题" },
];

export const heroStats = [
  { value: "203", unit: "集", label: "动画正片集数" },
  { value: "2006", unit: "年", label: "动画开播年份" },
  { value: "7", unit: "种", label: "死气之炎属性" },
  { value: "42", unit: "卷", label: "漫画原作单行本" },
];

export const quickFacts = [
  { label: "作品原名", value: "家庭教師ヒットマンREBORN!" },
  { label: "常见译名", value: "家庭教师HITMAN REBORN! / 我的家庭教师" },
  { label: "原作者", value: "天野明" },
  { label: "漫画连载", value: "集英社《周刊少年Jump》" },
  { label: "动画播出", value: "2006 年 — 2010 年" },
  { label: "动画集数", value: "正片约 203 集（另有特别篇）" },
  { label: "作品类型", value: "热血 / 搞笑 / 战斗 / 成长" },
  { label: "主要舞台", value: "并盛町 → 意大利黑手党世界" },
];

export const storyParagraphs = [
  "泽田纲吉（人称“废柴纲”）原本只是个成绩垫底、运动神经糟糕、处处不顺的普通中学生。某天，一个穿着西装、戴着礼帽的婴儿突然出现在他家，自称是意大利杀手“里包恩”，并且要以“家庭教师”的身份留在他身边。",
  "里包恩的使命只有一个：把一无是处的纲吉，培养成意大利最强黑手党家族“彭格列”的第十代首领。他随身携带的“死气弹”一旦命中额头，被打中的人就会在极限状态下拼死完成生前最遗憾的事，于是纲吉的日常被彻底打乱。",
  "作品的前半段是密集的搞笑日常，形形色色的杀手、同学与怪人接连登场；进入“黑曜篇”之后，故事全面转向热血战斗，死气之炎、彭格列指环、匣兵器等设定接连铺开，伙伴之间的羁绊与各自的成长成为真正的看点。",
  "从校园里的风纪委员到来自十年后的敌人，纲吉一次次被迫站到最前线，也逐渐从“什么都不想做的废柴”成长为愿意为伙伴承担一切的领袖。",
];

export const storyHighlights = [
  { icon: "ri-emotion-laugh-line", title: "爆笑日常开局", text: "前期单元剧节奏轻快，吐槽与无厘头桥段密集，是许多观众的入坑起点。" },
  { icon: "ri-fire-line", title: "硬核热血战斗", text: "黑曜篇起全面转型，属性相克与指环战让每一场对决都充满策略感。" },
  { icon: "ri-group-line", title: "群像塑造扎实", text: "主角团与敌对阵营都有鲜明性格和成长线，几乎没有纯粹的工具人。" },
];

export const characters = [
  {
    name: "泽田纲吉",
    alias: "阿纲 / 废柴纲",
    flame: "大空",
    role: "彭格列十代首领候补",
    desc: "本作主角。性格温和、畏惧麻烦，却在一次次极限状态中展现出为伙伴拼命的一面。",
    tags: ["主角", "大空之炎", "成长线"],
  },
  {
    name: "里包恩",
    alias: "Reborn",
    flame: "—",
    role: "纲吉的家庭教师",
    desc: "来自意大利的杀手婴儿，以家庭教师身份训练纲吉。也是阿尔柯巴雷诺（彩虹之子）之一。",
    tags: ["家庭教师", "彩虹之子", "杀手"],
  },
  {
    name: "狱寺隼人",
    alias: "炸弹隼人",
    flame: "岚",
    role: "岚之守护者",
    desc: "一心追随纲吉的左右手，脾气火爆、嘴上不饶人，实则把家族看得比什么都重要。",
    tags: ["守护者", "岚之炎", "忠诚"],
  },
  {
    name: "山本武",
    alias: "棒球少年",
    flame: "雨",
    role: "雨之守护者",
    desc: "并盛中学棒球社主力，性格开朗随和，把战斗当成另一种“比赛”来认真对待。",
    tags: ["守护者", "雨之炎", "开朗"],
  },
  {
    name: "蓝波",
    alias: "Lambo",
    flame: "雷",
    role: "雷之守护者",
    desc: "波维诺家族出身的婴儿杀手，爱哭又爱闹，却藏着十年后截然不同的强大形态。",
    tags: ["守护者", "雷之炎", "搞笑担当"],
  },
  {
    name: "云雀恭弥",
    alias: "并盛风纪委员长",
    flame: "云",
    role: "云之守护者",
    desc: "并盛中学风纪委员长，孤高好战，热爱并盛的一切，只对“强者”抱有纯粹的兴趣。",
    tags: ["守护者", "云之炎", "孤高"],
  },
  {
    name: "六道骸",
    alias: "骸",
    flame: "雾",
    role: "雾之守护者",
    desc: "黑曜篇登场的关键角色，幻术与精神操控的高手，立场与手段都难以预料。",
    tags: ["守护者", "雾之炎", "幻术"],
  },
  {
    name: "笹川了平",
    alias: "极限了平",
    flame: "晴",
    role: "晴之守护者",
    desc: "拳击社的狂热部长，凡事都讲究“极限”，用最直白的方式守护伙伴。",
    tags: ["守护者", "晴之炎", "热血"],
  },
  {
    name: "三浦春",
    alias: "小春",
    flame: "—",
    role: "纲吉的同学",
    desc: "活泼开朗、行动力十足的同学，为日常篇带来大量轻松活泼的气氛。",
    tags: ["日常篇", "同学", "活泼"],
  },
  {
    name: "笹川京子",
    alias: "京子",
    flame: "—",
    role: "纲吉憧憬的对象",
    desc: "温柔善良的同班同学，是纲吉在并盛生活中重要的精神寄托之一。",
    tags: ["日常篇", "同学", "温柔"],
  },
];

export const arcs = [
  {
    id: "arc-daily",
    title: "日常篇",
    range: "开篇阶段",
    tone: "轻松搞笑",
    summary: "里包恩登场，纲吉的平静生活被彻底打乱。各类杀手、怪人与同学轮番出现，单元剧式的搞笑段落确立了作品的初期基调。",
    points: ["里包恩以家庭教师身份登场", "死气弹与“拼死”设定建立", "主要伙伴陆续亮相"],
  },
  {
    id: "arc-kokuyo",
    title: "黑曜篇",
    range: "转型节点",
    tone: "热血战斗",
    summary: "校园里接连发生袭击事件，幕后的六道骸浮出水面。这一篇章让作品从日常搞笑正式迈向硬核战斗路线。",
    points: ["六道骸与黑曜中学登场", "守护者雏形初现", "奠定战斗漫基础"],
  },
  {
    id: "arc-varia",
    title: "VS瓦利安篇",
    range: "戒指争夺战",
    tone: "高燃神作章节",
    summary: "为了决定彭格列十代首领的继承权，守护者们与瓦利安暗杀部队展开指环争夺战，属性相克的战斗系统开始大放异彩。",
    points: ["彭格列指环正式登场", "守护者各自对阵瓦利安", "属性战成为核心看点"],
  },
  {
    id: "arc-future",
    title: "未来篇",
    range: "十年后世界",
    tone: "世界观扩张",
    summary: "纲吉一行人被意外送往十年后的世界，面对统治世界的白兰与米尔菲欧雷家族，匣兵器与新的战斗形态全面登场。",
    points: ["十年后世界与白兰登场", "匣兵器（动物指环）系统", "绝境反击的高潮大战"],
  },
  {
    id: "arc-inheritance",
    title: "继承式篇",
    range: "家族传承",
    tone: "考验与对决",
    summary: "觊觎继承权的势力接连登场，彭格列家族的传承成为新的考验，纲吉必须在压力中真正站稳十代首领的位置。",
    points: ["继承仪式相关势力登场", "家族历史进一步展开", "纲吉的领袖定位受检验"],
  },
  {
    id: "arc-arcobaleno",
    title: "阿尔柯巴雷诺的诅咒篇",
    range: "深层秘密",
    tone: "世界观收束",
    summary: "关于彩虹之子（阿尔柯巴雷诺）的秘密被逐步揭晓，里包恩等婴儿杀手背负的诅咒成为故事更深层的核心谜题。",
    points: ["揭晓彩虹之子的秘密", "里包恩的过去被触及", "世界观与人物动机收束"],
  },
];

export const flames = [
  { name: "大空", meaning: "调和与包容", color: "primary", desc: "彭格列首领的象征属性，代表包容与调和，能够孕育并统合其他属性。" },
  { name: "岚", meaning: "破坏", color: "accent", desc: "以强烈的破坏力著称，攻击性与爆发力在守护者属性中名列前茅。" },
  { name: "雨", meaning: "镇静", color: "primary", desc: "象征镇静与平息，擅长卸去对手的锐气，让战斗节奏回到自己掌握。" },
  { name: "晴", meaning: "活性", color: "secondary", desc: "代表活性与再生，能够强化自身状态与恢复能力，越战越勇。" },
  { name: "雷", meaning: "硬化", color: "accent", desc: "以硬化与坚固为核心，防御力极高，是队伍中坚实的屏障。" },
  { name: "云", meaning: "增殖", color: "secondary", desc: "象征增殖与独立，孤高而不受拘束，战斗风格自由且难以捉摸。" },
  { name: "雾", meaning: "构筑", color: "primary", desc: "主导幻觉与构筑，能够以幻术扭曲现实，是最难防范的属性之一。" },
];

export const channels = [
  {
    name: "樱花动漫",
    type: "在线播放渠道",
    icon: "ri-movie-2-line",
    desc: "国内观众较常用来追更与补番的动漫站点之一，页面按番剧分类整理，方便按名称检索作品。",
    notes: ["按番剧名或拼音检索", "通常提供分集列表", "画质与更新速度因资源而异"],
  },
  {
    name: "风车动漫",
    type: "在线播放渠道",
    icon: "ri-tv-2-line",
    desc: "另一个常被提及的动漫播放站点，资源覆盖面较广，适合作为查找全集资源的补充渠道。",
    notes: ["番剧库覆盖面较广", "支持分集与合集浏览", "资源来源与稳定性差别较大"],
  },
  {
    name: "全集资源",
    type: "资源类型",
    icon: "ri-stack-line",
    desc: "指按集数完整收录的观看形式，适合想要一次性补完、或按顺序重温整部作品的观众。",
    notes: ["按顺序完整收录", "适合补番与重温", "建议按篇章顺序观看"],
  },
  {
    name: "未删减版",
    type: "资源类型",
    icon: "ri-scissors-cut-line",
    desc: "指完整保留剧情片段的版本。不同渠道的剪辑差异可能影响观感，追番时可按需留意。",
    notes: ["保留完整剧情片段", "不同渠道存在差异", "观看前可先确认版本说明"],
  },
];

export const channelTips = [
  { icon: "ri-search-eye-line", title: "先确认作品名", text: "用“家庭教师REBORN”或“我的家庭教师”等常见译名检索，命中率更高。" },
  { icon: "ri-list-ordered", title: "对照集数观看", text: "不同渠道的分集编号可能略有差异，建议按篇章顺序对照观看。" },
  { icon: "ri-signal-tower-line", title: "留意渠道稳定性", text: "第三方渠道的资源与线路时常变动，建议多准备一个备用渠道。" },
  { icon: "ri-shield-check-line", title: "优先正版平台", text: "若国内视频平台有正版上架，优先选择正版来源，观看体验更稳定。" },
];

export const watchSteps = [
  { step: "01", title: "从日常篇起步", text: "不要急着跳到战斗，日常篇交代了人物关系与性格，是理解后文的基础。" },
  { step: "02", title: "耐心度过前期", text: "前期节奏偏单元剧，若觉得慢，可以适当加快速度，但建议不要整段跳过。" },
  { step: "03", title: "戒指争夺战是第一个高峰", text: "VS瓦利安篇通常被观众视为第一个高燃阶段，属性战从这里正式成型。" },
  { step: "04", title: "未来篇注意世界观", text: "十年后世界引入了匣兵器与新的势力设定，建议按顺序观看以免混乱。" },
  { step: "05", title: "补完动画再看漫画", text: "动画与漫画在剧情进度上并非完全一致，看完动画后可继续补漫画后续内容。" },
];

export const faqs = [
  {
    q: "《我的家庭教师》和《家庭教师HITMAN REBORN!》是同一部作品吗？",
    a: "是的。“我的家庭教师”是不少观众对《家庭教师HITMAN REBORN!》的常用叫法，作品改编自天野明的同名漫画，动画于 2006 年至 2010 年间播出。",
  },
  {
    q: "这部动画一共有多少集？",
    a: "动画正片约 203 集，此外还有若干特别篇与相关影像内容。不同渠道的分集统计方式可能略有出入，建议以具体渠道的列表为准。",
  },
  {
    q: "前期的日常篇需要跳过吗？",
    a: "不建议整段跳过。日常篇虽然节奏轻松，但交代了纲吉与伙伴们的性格和关系，很多笑点与羁绊都是后文战斗的情感基础。如果觉得慢，可以稍微加快观看速度。",
  },
  {
    q: "全集资源和未删减版有什么区别？",
    a: "“全集资源”强调的是按集数完整收录，方便按顺序补完；“未删减版”强调完整保留剧情片段。两者关注点不同，具体差异取决于渠道提供的版本。",
  },
  {
    q: "樱花动漫、风车动漫是什么？",
    a: "它们是被观众广泛提及的动漫观看渠道名称。不同渠道的资源来源、画质与稳定性存在差异，观看时可以多方对比，若正版平台有上架则优先选择正版。",
  },
  {
    q: "没看过原作可以直接看动画吗？",
    a: "可以。动画本身是一条完整的叙事线，从日常篇开始就已经在交代设定与人物。若想了解动画之后的剧情，可以再补漫画原作的后续内容。",
  },
  {
    q: "第一次观看推荐什么顺序？",
    a: "推荐按播出顺序观看：日常篇 → 黑曜篇 → VS瓦利安篇 → 未来篇 → 继承式篇 → 阿尔柯巴雷诺的诅咒篇。这样能获得最完整的情感与设定递进。",
  },
];

export const keywords = [
  "我的家庭教师",
  "动漫在线观看",
  "全集资源",
  "未删减版",
  "樱花动漫",
  "风车动漫",
  "番剧资源",
  "播放地址",
];